<script>
export default {
  name: 'VcStyle',
  render (createElement) {
    return createElement('style', this.$slots.default)
  }
}
</script>


// WEBPACK FOOTER //
// style.vue?1f8f2b96